import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { getInformation } from '../../constants/ci-information.constant';
import { RouterModule } from '@angular/router';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule, NgFor, NgIf, RouterModule, NgxTypedJsModule],
  templateUrl: './gallery.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GalleryComponent implements OnInit {

  @Input()
  public id!: any;

  @Input()
  public typedMessage!: boolean;

  public data: any;

  public safeUrl!: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this._getInformation(this.id);
  }
  
  public scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public scrollToFeatureSection(id: string): any {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  public getYoutubeID(url: string): string {
    const regex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : '';
  }

  private _getInformation(slug: string) {
    this.data = getInformation(slug);
    
    if (this.data) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data?.assets?.videoUrl);
    }
  }
}
